
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.719 25.538l12 10C22.006 36.613 24 35.712 24 34V14c0-1.713-1.994-2.613-3.281-1.537l-12 10a2.007 2.007 0 000 3.075zm16 0l12 10C38.006 36.613 40 35.712 40 34V14c0-1.713-1.994-2.613-3.281-1.537l-12 10a2.007 2.007 0 000 3.075z","fill":"#535353"}})])
          )
        }
      }
    